"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-11 w-full rounded-[14px] border border-[var(--control-border,#a1a1aa)] bg-[var(--control-bg,#fff)] px-3 py-2 text-sm text-[var(--control-text,#18181b)] placeholder:text-[var(--control-placeholder,#71717a)] transition-[border-color,box-shadow,background-color] focus:outline-none focus:ring-2 focus:ring-[var(--control-focus,#18181b)] focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
